import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { FaTimes, FaEdit, FaToggleOn, FaToggleOff, FaTrash } from 'react-icons/fa'
import { Modal } from '../../../../UI'
import { toggleStaffStatus, deleteStaff } from '../../../../store/actions/staff'
import StaffForm from '../StaffForm'
import Container from './styles'

const StaffDetails = ({ show, handleClose, staff }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('overview')
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [showEditForm, setShowEditForm] = useState(false)

  if (!staff) return null

  const handleToggleStatus = async () => {
    await dispatch(toggleStaffStatus(staff.id))
  }

  const handleDelete = async () => {
    const result = await dispatch(deleteStaff(staff.id))
    if (result.success) {
      handleClose()
      navigate('/company/dashboard/staff')
    }
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A'
    return new Date(timestamp).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  return (
    <Modal showModal={show} onClose={handleClose} showCloseBtn={false}>
      <Container>
        <div className="staff-details--container">
          <header>
            <h2>Staff Details</h2>
            <button className="close--btn" onClick={handleClose}>
              <FaTimes />
            </button>
          </header>

          <div className="tabs--container">
            <button
              className={`tab ${activeTab === 'overview' ? 'active' : ''}`}
              onClick={() => setActiveTab('overview')}
            >
              Overview
            </button>
            <button
              className={`tab ${activeTab === 'actions' ? 'active' : ''}`}
              onClick={() => setActiveTab('actions')}
            >
              Actions
            </button>
          </div>

          <div className="details--content">
            {activeTab === 'overview' ? (
              <div className="tab-content">
                <div className="detail--row">
                  <label>Full Name</label>
                  <p>{staff.fullName || `${staff.firstName} ${staff.lastName}`}</p>
                </div>

                <div className="detail--row">
                  <label>Email</label>
                  <p>{staff.email}</p>
                </div>

                <div className="detail--row">
                  <label>Phone</label>
                  <p>{staff.phone}</p>
                </div>

                <div className="detail--row">
                  <label>Role</label>
                  <p>{staff.role}</p>
                </div>

                <div className="detail--row">
                  <label>Status</label>
                  <p className={`status ${staff.status?.toLowerCase()}`}>
                    {staff.status}
                  </p>
                </div>

                <div className="detail--row">
                  <label>Date Added</label>
                  <p>{formatDate(staff.createdAt)}</p>
                </div>

                <div className="detail--row">
                  <label>Last Updated</label>
                  <p>{formatDate(staff.updatedAt)}</p>
                </div>
              </div>
            ) : (
              <div className="tab-content actions-tab">
                <div className="action--card">
                  <div className="action--info">
                    <h4>Edit Staff Member</h4>
                    <p>Update staff member information and role</p>
                  </div>
                  <button className="btn-edit" onClick={() => setShowEditForm(true)}>
                    <FaEdit />
                    Edit
                  </button>
                </div>

                <div className="action--card">
                  <div className="action--info">
                    <h4>Toggle Status</h4>
                    <p>
                      Current status: <strong>{staff.status}</strong>
                    </p>
                  </div>
                  <button className="btn-status" onClick={handleToggleStatus}>
                    {staff.status === 'ACTIVE' ? <FaToggleOff /> : <FaToggleOn />}
                    {staff.status === 'ACTIVE' ? 'Deactivate' : 'Activate'}
                  </button>
                </div>

                <div className="action--card danger">
                  <div className="action--info">
                    <h4>Delete Staff Member</h4>
                    <p>Permanently remove this staff member from your company</p>
                  </div>
                  <button
                    className="btn-delete"
                    onClick={() => setShowDeleteConfirm(true)}
                  >
                    <FaTrash />
                    Delete
                  </button>
                </div>

                {showDeleteConfirm && (
                  <div className="delete-confirm">
                    <p>Are you sure you want to delete this staff member?</p>
                    <p className="warning">
                      This action cannot be undone. They will lose access to your
                      company dashboard.
                    </p>
                    <div className="confirm-actions">
                      <button
                        className="btn-cancel"
                        onClick={() => setShowDeleteConfirm(false)}
                      >
                        Cancel
                      </button>
                      <button className="btn-confirm-delete" onClick={handleDelete}>
                        Yes, Delete
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {showEditForm && (
          <StaffForm 
            show={showEditForm} 
            handleClose={() => {
              setShowEditForm(false)
              handleClose()
            }} 
            editData={staff}
          />
        )}
      </Container>
    </Modal>
  )
}

export default StaffDetails
